<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper pt-0">
  <div class="d-flex flex-row justify-content-between pb-2">
    <div class="w-75">
      <label class="lbl_pos_field">{{'TAX_RATE.NAME' | translate}}
        <i *ngIf="errorModel!=null && errorModel['Name']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end" pTooltip="{{errorModel['Name']|translate}}"
           tooltipPosition="top"></i>
      </label>
      <input type="text" class="primary_input_field mt-1" [(ngModel)]="taxRateModel.name" placeholder="Eg. VAT">
    </div>
    <div class="w-25">
      <label class="lbl_pos_field">{{'TAX_RATE.RATE' | translate}}
        <i *ngIf="errorModel!=null && errorModel['Rate']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end" pTooltip="{{errorModel['Rate']|translate}}"
           tooltipPosition="top"></i>
      </label>
      <span class="p-input-icon-right">
        <i class="pi pi-percentage" style="color: var(--app-mono-background)"></i>
        <input id="tax_rate_rate_input" type="number" min="0" class="primary_input_field mt-1 pe-4" [(ngModel)]="taxRateModel.rate"/>
      </span>
    </div>
  </div>
  <div class="w-100 mb-3 mt-2 d-flex justify-content-start">
    <p-checkbox [binary]="true" inputId="default_tax_rate" [disabled]="disableDefaultDeselect"
                [(ngModel)]="taxRateModel.isDefault" styleClass="checkbox-circle"></p-checkbox>
    <label [for]="'default_tax_rate'" class="venue_checkbox_label">{{'TAX_RATE.DEFAULT_TAX' | translate}}</label>
  </div>
  <div class="w-100 mt-4">
    <button class=" btn-group-text create_btn w-100 mb-2 m-0" *ngIf="!enableEdit"
            (click)="publishOrUpdateTaxRate(taxRateModel)">
      {{'TAX_RATE.PUBLISH' | translate}}</button>
    <button class=" btn-group-text create_btn w-100 mb-2 m-0" *ngIf="enableEdit"
            (click)="publishOrUpdateTaxRate(taxRateModel, true)">
      {{'SAVE' | translate}}</button>
  </div>
</div>
